import { FunctionComponent, ReactNode } from 'react';
import { Languages } from '../top-menu/top-menu';

export type Props = {
  language: Languages;
  className?: string;
  htmlFor?: string;
  children: ReactNode;
  style?: React.CSSProperties | undefined;
};

const LABEL: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {window.location.href.indexOf('/' + props.language + '/') !== -1 && (
        <label className={props.className} htmlFor={props.htmlFor} style={props.style}>
          {props.children}
        </label>
      )}
    </>
  );
};

export default LABEL;
